module.exports = __webpack_public_path__ + "img/D2-c.8b2c6942.jpg";